import { ChangeDetectionStrategy, Component, inject, model } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { helpLinks, HelpLink } from '@layout/help-menu/models/help-link.interface';
import { TogglePanelComponent } from '@layout/help-menu/components/toggle-panel/toggle-panel.component';
import { MedalliaFacade } from '@core/medallia/facades/medallia.facade';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { Permission } from '@kaseya-shared';
import { WINDOW } from '@kaseya-utils';

@Component({
  selector: 'itc-help-toggle-panel',
  templateUrl: 'help-toggle-panel.component.html',
  styleUrl: 'help-toggle-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, TogglePanelComponent, RouterLink, RouterLinkActive],
})
export class HelpTogglePanelComponent {
  private readonly medalliaFacade = inject(MedalliaFacade);
  private readonly permissionsFacade = inject(PermissionsFacade);
  private readonly window = inject(WINDOW);

  readonly isOpen = model(false);

  readonly helpLinks: Record<keyof typeof helpLinks, HelpLink> = helpLinks;
  readonly hasAccessToMedalliaIntegrationView = this.permissionsFacade.hasPermission(Permission.MedalliaIntegrationView);
  readonly hasAccessToLegalTermsArchiveView = this.permissionsFacade.hasPermission(Permission.LegalTermsArchiveView);

  openLink(link: string): void {
    this.window.open(link, '_blank', 'noopener,noreferrer');
  }

  provideFeedback(): void {
    this.medalliaFacade.showMedalliaSurvey();
  }

  closePanel(): void {
    this.isOpen.set(false);
  }
}
